const initialState = {
    eventsByRecons: [],

};
export default initialState;